import { fonts, colors } from '../../../theme';

const style = (theme) => ({
  gridContainer: {
    padding: '2vw 2vw 2vw 3vw !important',
    minHeight: '65vh',
  },
  logText: {
    '& .MuiInputLabel-root.MuiInputLabel-shrink': {
      transform: 'translate(0vw, -1vw)',
      margin: '0px 10px !important',
      backgroundColor: 'white',
    },
    marginTop: '20px !important',
  },
  viewLogs: {
    '@media (min-width: 1200px)': {
      fontSize: '1vw',
    },
    fontFamily: fonts.fontType.roboto,
    fontWeight: fonts.fontWeight.medium,
    display: 'flex',
    color: colors.actionIconsColor,
    marginLeft: '1vw',
    textDecoration: 'underline',
    cursor: 'pointer',
    marginTop: '1vw',
  },
  titleRow: {
    justifyContent: 'space-between',
  },
  headerTitle: {
    fontWeight: fonts.fontWeight.bold,
    '@media (min-width: 1200px)': {
      fontSize: '1.5vw',
      padding: '1vw 0.5vw 1vw 0',
    },
  },
  subHeaderTitle: {
    fontWeight: '400',
    color: '#505050',
    '@media (min-width: 1200px)': {
      fontSize: '.9vw',
      padding: '1vw 0.5vw 0.6vw 0',
    },
  },
  headerDesc: {
    fontWeight: fonts.fontWeight.bold,
    '@media (min-width: 1200px)': {
      fontSize: '1vw',
    },
    color: colors.settingsDescription,
    padding: '1.4vw 1vw 1vw 0',
  },
  LateFeeAmount: {
    padding: '1vw 0vw 1vw 2vw !important',
    '& .MuiFormControl-root': {
      marginLeft: '-0.5vw !important',
      '@media (min-width: 1200px)': {
        height: '2.5vw',
      },
      '& .MuiTableCell-head': {
        padding: '1vw 0vw 1vw 2vw',
      },
    },
  },
  secButton: {
    marginTop: '1.5vw !important',
    color: '#1976d2 !important',
    border: '0.1px solid #1976d2',
    '@media (min-width: 1200px)': {
      height: '3vw',
      fontSize: '1vw',
      padding: '0.8vw',
      width: '13vw',
    },
    background: 'white',
    boxSizing: 'border-box',
    fontFamily: 'Roboto, sans-serif',
    marginRight: '1vw',
    borderRadius: '0.4vw !important',
    textTransform: 'none',
    '& .MuiSvgIcon-root': {
      '@media (min-width: 1200px)': {
        width: '0.8vw',
        height: '0.8vw',
      },
    },
  },
  actionBtn: {
    marginTop: '1.5vw !important',
    '@media (min-width: 1200px)': {
      minWidth: '13.021vw !important',
      height: '3vw !important',
      fontSize: '0.9vw',
    },
    marginRight: '1.5vw !important',
  },
  addAcademicBtn: {
    '@media (min-width: 1200px)': {
      minWidth: '13.021vw !important',
      height: '3vw !important',
      fontSize: '0.9vw',
    },
    paddingRight: '1.7vw',
    textAlign: 'right',
  },
  tableCells: {
    '@media (min-width: 1200px)': {
      width: '20vw',
      '& .MuiInputLabel-root': {
        backgroundColor: colors.white,
      },
    },
  },

  datePicker: {
    margin: '0.5vw 0',
    height: '4vw',
    '& .MuiInputLabel-root': {
      backgroundColor: colors.white,
      paddingRight: '10px !important',
    },
  },

  datePicke: {
    width: '10vw',
    margin: '0.5vw 0',
    height: '4vw',
    '@media (max-width: 1200px)': {
      width: '150px',
    },
    '& .MuiInputLabel-root': {
      backgroundColor: colors.white,
      marginLeft: '30px !important',
    },
  },

  tableCellCourse: {
    '@media (min-width: 1200px)': {
      width: '11vw',
    },
  },
  title: {
    '@media (min-width: 1200px)': {
      fontSize: '1.2vw',
      padding: '1vw 1vw 1vw 0',
    },
  },
  dropdown: {
    '@media (min-width: 1200px)': {
      minWidth: '25vw !important',
      marginTop: '0 !important',
      maxWidth: '20vw',
      fontSize: '1vw',
      marginLeft: '-1vw',
    },
  },
  registrationTable: {
    width: '99%',
    '& .MuiOutlinedInput-root': {
      '@media (min-width: 1200px)': {
        width: '13vw !important',
      },
    },
  },
  select: {
    padding: '0',
    transform: 'translate(16px, -6px) scale(1)',
    '@media (min-width: 1200px)': {
      fontSize: '1vw',
      height: '2vw',
      transform: 'translate(16px, -6px) scale(1)',
    },
    '& .MuiSelect-select': {
      paddingRight: '1vw !important',
      minWidth: '75px !important',
      '@media (min-width: 1200px)': {
        minWidth: '5vw !important',
        minHeight: '1vw !important',
      },
    },
    '& svg': {
      '@media (min-width: 1200px)': {
        width: '1.5vw',
        height: '1.5vw',
      },
    },
  },
  dropdownWrapper: {
    justifyContent: 'space-between',
    '& .MuiInputLabel-root.MuiInputLabel-shrink': {
      transform: 'translate(-1vw, -0.7vw)',
    },
  },
  tableHead: {
    '& .MuiTableCell-head': {
      fontWeight: `${fonts.fontWeight.bold}`,
      color: '#015EEA',
    },
    '& .MuiTableCell-root': {
      borderBottom: '0.2vw solid #015EEA',
      '@media (min-width: 1200px)': {
        fontSize: '1vw',
      },
      padding: '1vw',
    },
  },
  tableBody: {
    '& .MuiTableCell-root': {
      borderBottom: 'none',
      '& p': {
        color: '#505050',
        fontWeight: '700',
      },
      backgroundColor: 'white',
      paddingRight: '10px',
      '@media (min-width: 1200px)': {
        fontSize: '1vw',
        padding: '0.3vw 1vw 1vw;',
      },
      '@media (max-width: 1199px)': {
        padding: '4.3vw 1vw 1vw;',
      },
    },
    '& .MuiTableRow-root:first-child': {
      display: 'contents',
    },
    '& .MuiTableRow-root:last-child': {
      borderBottom: '1px solid #858585',
    },
    '& .MuiTableCell-body': {
      '& .MuiInputLabel-root': {
        color: '#104F96',
        transform: 'translate(16px, -3px) scale(1)',
        backgroundColor: colors.white,
        paddingRight: '10px !important',
        '@media (min-width: 1200px)': {
          fontSize: '0.7vw !important',
          transform: 'translate(1vw, -3px) scale(1)',
        },
        fontFamily: fonts.fontType.roboto,
        marginLeft: 0,
        [theme.breakpoints.down('lg')]: {
          fontSize: '12px !important',
        },
        [theme.breakpoints.down('md')]: {
          fontSize: '10px !important',
        },
      },
      '& .MuiFormControl-root .MuiFormControl-root': {
        '& .MuiTypography-root': {
          fontSize: '1vw',
        },
        '& .MuiInputLabel-root': {
          transform: 'translate(16px, -6px) scale(1)',
          '@media (min-width: 1200px)': {
            transform: 'translate(1vw, 0vw) scale(1)',
          },
        },
      },
      '& .MuiOutlinedInput-root': {
        '@media (min-width: 1200px)': {
          height: '3vw',
        },
        borderRadius: '0.4vw',
        paddingLeft: '0.2vw',
      },
    },
    '& #datePickerDiv': {
      '@media (min-width: 1200px)': {
        height: '2vw',
      },
      transform: 'translate(0vw, 0.2vw) scale(1)',
      paddingLeft: '0.9vw',
    },
  },
  input: {
    textAlign: 'right',
    '& .MuiInputBase-input': {
      textAlign: 'right !important',
    },
  },
  errorText: {
    '@media (min-width: 1200px)': {
      fontSize: '0.7vw !important',
    },
    color: 'red !important',
    fontWeight: '500 !important',
  },
  academicErrorText: {
    '@media (min-width: 1200px)': {
      fontSize: '0.9vw !important',
    },
    color: 'red',
  },
  switchText: {
    fontSize: '0.9vw !important',
    textAlign: 'center',
    [theme.breakpoints.down('lg')]: {
      fontSize: '12px !important',
    },
  },
  switchHeading: {
    fontSize: '1vw !important',
    fontWeight: fonts.fontWeight.bold,
    textAlign: 'center',
    [theme.breakpoints.down('lg')]: {
      fontSize: '13px !important',
    },
  },
  switchUi: {
    flexDirection: 'row',
    justifyContent: 'center',
    width: '100%',
    alignItems: 'center',
    '& p': {
      margin: '0 8px !important',
      '@media (min-width: 1200px)': {
        fontSize: '0.9vw',
      },
      [theme.breakpoints.down('lg')]: {
        fontSize: '12px !important',
      },
    },
    '& span': {
      marginTop: '0 !important',
      '@media (min-width: 1200px)': {
        fontSize: '0.9vw',
      },
      [theme.breakpoints.down('lg')]: {
        fontSize: '12px !important',
      },
    },
    '& .MuiSwitch-switchBase': {
      padding: 3,
      '&.Mui-checked+.MuiSwitch-track': {
        background: colors.greenShade,
      },
    },
    '& .MuiSwitch-thumb': {
      width: 10,
      height: 10,
    },
  },
  inActiveText: {
    color: colors.redShade,
  },
  activeText: {
    color: colors.greenShade,
  },
  studentBox: {
    maxWidth: 'unset !important',
    '& .MuiGrid-item': {
      maxWidth: 'unset !important',
      textAlign: 'right !important',
    },
  },
  alertprimary: {
    height: '3vw',
    display: 'flex',
    color: colors.green,
  },
  alert: {
    height: '3vw',
    display: 'flex',
    color: colors.red,
  },
  dialogContent: {
    '& .MuiGrid-root': {
      '@media (max-width: 600px)': {
        height: '13vw !important',
      },
      '@media (max-width: 425px)': {
        height: '15vw !important',
      },
    },
  },
  dialogButtons: {
    justifyContent: 'flex-end',
    padding: '0 10px',
    '& .MuiButton-root': {
      '@media (min-width: 1200px)': {
        minWidth: '10vw !important',
        height: '2.7vw !important',
        fontSize: '0.8vw',
      },
    },
  },
  popupButton: {
    display: 'flex',
    justifyContent: 'end',
    '& .MuiButtonBase-root.MuiButton-root': {
      '@media (min-width: 1200px)': {
        height: '3vw !important',
        minWidth: '9vw !important',
      },
      marginRight: '15px',
      borderRadius: '4px',
    },
  },
  successText: {
    color: colors.green,
  },

  successCont: {
    marginTop: '3vh',
    marginBottom: '3vh',
  },
});

export default style;
